export function itemCardStickyBar() {
    var itemCard = document.querySelector('.itemcardMain .itemcardBuybox');
    var stickyBar = document.querySelector('.js-itemcardStickyBuyBanner');
    var orderBoxContainer = document.querySelector('.itemcardBuybox .orderbox');
    var newsletterBanner = document.querySelector('.newsletterBanner');
    var footers = document.querySelectorAll('.footer');
    var stickyBarVisible = true;


    function addIconToOrderButton() {
        var orderButtonInStickyBar = stickyBar.querySelector('.orderButton');
        if (orderButtonInStickyBar && !orderButtonInStickyBar.querySelector('.icon-basket')) {
            orderButtonInStickyBar.innerHTML += "<i class=\"icon icon-basket\"></i>";
        }
    }

    function removeIconFromOrderButton() {
        var orderButtonInStickyBar = stickyBar.querySelector('.orderButton');
        if (orderButtonInStickyBar) {
            var iconBasket = orderButtonInStickyBar.querySelector('.icon-basket');
            if (iconBasket) {
                iconBasket.remove();
            }
        }
    }

    function updateStickyBarVisibility() {
        var stickyAreaRect = itemCard.getBoundingClientRect();
        var stickyAreaVisible = stickyAreaRect.bottom > 0 && stickyAreaRect.top < window.innerHeight;

        var footerVisible = Array.from(footers).some(footer => {
            var footerRect = footer.getBoundingClientRect();
            return footerRect.top < window.innerHeight && footerRect.bottom > 0;
        });

        var newsletterBannerRect = newsletterBanner.getBoundingClientRect();
        var newsletterBannerVisible = newsletterBannerRect.bottom > 0 && newsletterBannerRect.top < window.innerHeight;

        stickyBarVisible = !(stickyAreaVisible || footerVisible || newsletterBannerVisible);

        if (stickyBarVisible) {
            moveToStickyBar();  // Call moveToStickyBar here
        } else {
            moveToOriginalPosition();  // Call moveToOriginalPosition here
        }
    }

    function moveToStickyBar() {
        var stickyBarProduct = stickyBar.querySelector('.stickyBarProduct');
        var chatButton = document.querySelector('.MuiScopedCssBaseline-root');
        var cookieButton = document.querySelector('.cmpwrapper');
        if (orderBoxContainer && stickyBarProduct) {
            stickyBarProduct.parentNode.insertBefore(orderBoxContainer, stickyBarProduct.nextSibling);
            addIconToOrderButton();
        }
        stickyBar.classList.add('visible');
        if (chatButton){
            chatButton.style.display = "none";
        }
        if (cookieButton){
            cookieButton.style.display = "none";
        }
    }

    function moveToOriginalPosition() {
        var originalPosition = document.querySelector('.itemcardBuybox .itemcardOrderboxActionsWrapper');
        var chatButton = document.querySelector('.MuiScopedCssBaseline-root');
        var cookieButton = document.querySelector('.cmpwrapper');
        if (orderBoxContainer && originalPosition) {
            removeIconFromOrderButton();
            originalPosition.appendChild(orderBoxContainer);
        }
        stickyBar.classList.remove('visible');
        if (chatButton){
            chatButton.style.display = "inherit";
        }
        if (cookieButton){
            cookieButton.style.display = "inherit";
        }
    }

    var observerCallback = function(entries) {
        entries.forEach(function(entry) {
            if (entry.target === itemCard) {
                isItemCardVisible = entry.isIntersecting;
                if (!entry.isIntersecting) {
                    moveToStickyBar();
                } else {
                    moveToOriginalPosition();
                }
            }
        });
        updateStickyBarVisibility();
    };

    window.addEventListener('scroll', function() {
        updateStickyBarVisibility();
    });

    var observerStickyBarCallback = function(entries) {
        entries.forEach(function(entry) {
            if (entry.target === itemCard) {
                isItemCardVisible = entry.isIntersecting;
                updateStickyBarVisibility();
            }
        });
    };

    var observerNewsletterBannerCallback = function(entries) {
        entries.forEach(function(entry) {
            if (entry.target === newsletterBanner) {
                isItemCardVisible = entry.isIntersecting;
                updateStickyBarVisibility();
            }
        });
    };

    var observerFooterCallback = function(entries) {
        entries.forEach(function(entry) {
            footers.forEach(function(footer) {
                if (entry.target === footer) {
                    isItemCardVisible = entry.isIntersecting;
                    updateStickyBarVisibility();
                }
            });
        });
    };

    var observer = new IntersectionObserver(observerCallback, { rootMargin: "100px" });
    var observerStickyBar = new IntersectionObserver(observerStickyBarCallback, { rootMargin: "300px" });
    if (itemCard) {
        observer.observe(itemCard);
        observerStickyBar.observe(itemCard);
    }

    var observerNewsletterBanner = new IntersectionObserver(observerNewsletterBannerCallback, {rootMargin: "0px"});
    if (newsletterBanner){
        observerNewsletterBanner.observe(newsletterBanner);
    }

    var observerFooter = new IntersectionObserver(observerFooterCallback, {rootMargin: "0px"});
    footers.forEach(function(footer) {
        observerFooter.observe(footer);
    });



}
